import React from 'react';
import AsperaDesktopFileUpload from './AsperaDesktopFileUpload';
import AsperaConnectFileUpload from './AsperaConnectFileUpload';
import { useUserProfile } from '../../hooks/reduxHooks';
import { isAuthorized } from '../../utils/userUtils';
import { permConst } from '../../constants/permConst';

const AsperaFileUpload = (props) => {
	const userProfile = useUserProfile();
	const useAsperaDesktop = isAuthorized(userProfile?.permissions ?? [], [
		permConst.ASPERA_DESKTOP.VIEW.ALL,
		permConst.ASPERA_DESKTOP.VIEW.COMPANY,
	]);

	if (useAsperaDesktop) {
		return <AsperaDesktopFileUpload {...props} />;
	}
	return <AsperaConnectFileUpload {...props} />;
};

export default AsperaFileUpload;
